import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import SeasonService from '@iso/services/SettingsService/ProductService/SeasonService';

function* viewSeason({ id }) {
    try {
        const response = yield call(SeasonService.getOne, id);
        yield put(actions.viewSeasonSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewSeasonFailed(extractError(error)));
    }
}

function* watchViewSeason() {
    yield takeEvery(
        types.REQUEST_VIEW_SEASON,
        viewSeason,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewSeason),
    ]);
}

export default viewSaga;
